var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.disabled ? '' : 'primary',"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.getSmsCode()}}},[_vm._v(" "+_vm._s(_vm.disabled ? _vm.countDown + ' 秒后重试' : '获取验证码')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }